import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SchoolProvider } from './context/SchoolContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/Login';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { FirstTimeSetup } from './pages/FirstTimeSetup';
import { ResetPassword } from './pages/ResetPassword';
import { StudentDashboard } from './pages/StudentDashboard';
import { TeacherDashboard } from './pages/TeacherDashboard';
import { AdminDashboard } from './pages/AdminDashboard';
import { DevDemoPage } from './pages/DevDemoPage';
import { CrossSchoolAccessPage } from './pages/CrossSchoolAccessPage';
import { ReportCardPrintPage } from './pages/ReportCardPrint';

const AppContent: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      
      <Route
        path="/first-time-setup"
        element={
          <ProtectedRoute>
            <FirstTimeSetup />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/change-password"
        element={
          <ProtectedRoute>
            <ChangePasswordPage />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/student"
        element={
          <ProtectedRoute allowedRoles={['student']}>
            <StudentDashboard />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/teacher"
        element={
          <ProtectedRoute allowedRoles={['teacher']}>
            <TeacherDashboard />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/dev"
        element={
          <ProtectedRoute allowedRoles={['dev']}>
            <DevDemoPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin"
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/cross-school"
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <CrossSchoolAccessPage />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/report-card-print"
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <ReportCardPrintPage />
          </ProtectedRoute>
        }
      />
      
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SchoolProvider>
          <AppContent />
        </SchoolProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;

